import { PHYSICS, PLAYER, WORLD } from "../constants";
import type { PlayerState } from "../engine/types";

export function createPlayer(): PlayerState {
  return {
    id: 0,
    x: PLAYER.START_X,
    y: WORLD.GROUND_Y - PLAYER.HEIGHT,
    w: PLAYER.WIDTH,
    h: PLAYER.HEIGHT,
    vx: 0,
    vy: 0,
    alive: true,
    lives: PLAYER.LIVES,
    jumping: false,
    ducking: false,
    invincibleUntilMs: 0,
    shieldCharges: PLAYER.SHIELD_CHARGES,
    shieldReadyAtMs: 0,
    multiplierUntilMs: 0,
  };
}

export interface PlayerInput {
  jumpPressed: boolean;
  duckHeld: boolean;
}

export function updatePlayer(
  p: PlayerState,
  input: PlayerInput,
  dtSec: number,
  nowMs: number
): void {
  // Duck
  if (input.duckHeld && !p.jumping) {
    if (!p.ducking) {
      p.ducking = true;
      p.h = PLAYER.DUCK_HEIGHT;
      p.y = WORLD.GROUND_Y - PLAYER.DUCK_HEIGHT;
    }
  } else if (p.ducking) {
    p.ducking = false;
    p.h = PLAYER.HEIGHT;
    p.y = WORLD.GROUND_Y - PLAYER.HEIGHT;
  }

  // Jump
  if (input.jumpPressed && !p.jumping && !p.ducking) {
    p.vy = PHYSICS.JUMP_VELOCITY;
    p.jumping = true;
  }

  // Gravity / vertical motion
  if (p.jumping) {
    p.vy += PHYSICS.GRAVITY * dtSec;
    p.y += p.vy * dtSec;
    if (p.y >= WORLD.GROUND_Y - p.h) {
      p.y = WORLD.GROUND_Y - p.h;
      p.vy = 0;
      p.jumping = false;
    }
  }

  // Expire timed buffs
  if (p.multiplierUntilMs && nowMs > p.multiplierUntilMs) {
    p.multiplierUntilMs = 0;
  }
}

export function isInvincible(p: PlayerState, nowMs: number): boolean {
  return nowMs < p.invincibleUntilMs;
}

export function takeHit(p: PlayerState, nowMs: number): boolean {
  if (isInvincible(p, nowMs)) return false;
  p.lives -= 1;
  p.invincibleUntilMs = nowMs + PLAYER.INVINCIBILITY_MS;
  if (p.lives <= 0) p.alive = false;
  return true;
}
